import { Typography } from '@mui/material';
import { Task, TaskRegardingValues } from '@trnsact/trnsact-shared-types';


interface Props {
  task: Task;
  isIndividualApp: boolean;
  isCoApplicant: boolean;
};


export const PageTitle = (props: Props): JSX.Element => {

  const titleByTask: Record<string, JSX.Element> = {
    [TaskRegardingValues.newSignorAndGuarantorSignature]: <Typography variant="h4">Personal Guarantor Authorization</Typography>,
    [TaskRegardingValues.signatures]: <SignaturesHeader {...props} />,
  };

  return titleByTask[props.task.regarding!] ?? null;
};


const SignaturesHeader = ({ isIndividualApp, isCoApplicant }: Props) => {
  if (!isIndividualApp) {
    return <Typography variant="h4">Owner Authorization</Typography>;
  }
  return isCoApplicant
    ? <Typography variant="h4">Co-applicant Authorization</Typography>
    : <Typography variant="h4">Applicant Authorization</Typography>;
};
